/* This file is autogenerated, see readme.md for instructions */
import HelpSvgIcon from '@bloomreach/banana-theme/icons/help.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const HelpIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <HelpSvgIcon />
    </Icon>
  );
});

HelpIcon.displayName = 'HelpIcon';

export default HelpIcon;
